export default __webpack_public_path__ + "static/media/sidebar2.42e1604d.jpg";